/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-08-06 12:57:40
 * @LastEditTime: 2021-08-06 13:01:32
 * @LastEditors: chenguobiao
 */
import { VuexModule, Module, Mutation } from 'vuex-module-decorators'
@Module({ namespaced: true })
export default class ReplayModule extends VuexModule {
  _nextStepFlag = true // 能否点击下一步
  get nextStepFlag() {
    return this._nextStepFlag
  }
  @Mutation
  setNextStepFlag(data) {
    this._nextStepFlag = data
  }
}
